var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data86",style:({
	  marginTop:_vm.list.top==0?0:'-120px'
  })},[_c('div',{staticClass:"data86Box"},[_c('div',{staticClass:"data86BoxOne"},[_vm._v("\n\t\t\t"+_vm._s(_vm.list.data.text1)+"\n\t\t")]),_c('div',{staticClass:"data86BoxTwo"},[_vm._v(_vm._s(_vm.list.data.text2))])])])}
var staticRenderFns = []

export { render, staticRenderFns }